import React, { useEffect, useRef, useState } from "react";
import OnGoingProject from "./OnGoingProject";
import TimeSpentProject from "./TimeSpentProject";
import TimeSpentTask from "./TimeSpentTask";
import DashboardOverview from "./DashboardOverview";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";
import { useAppDispatch } from "../../hooks";
import { getDasboardAsync } from "../../services/reducers/adminReducer";
import { formatDate } from "../../utils/common";
import DashboardOverviewEmpty from "./DashboardOverviewEmpty";
import OnGoingProjectEmpty from "./OnGoingProjectEmpty";

export const EchoPulseDatePicker = styled.div`
  overflow: hidden;
  .react-datepicker__calendar-icon {
    display: none;
  }

  // .react-datepicker-wrapper {
  //   width: 152px;
  // }

  .react-datepicker-wrapper input {
    padding: 8.5px 10px;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #232323;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z' fill='%23292D32'/%3E%3Cpath d='M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z' fill='%23292D32'/%3E%3Cpath d='M20.5 9.83997H3.5C3.09 9.83997 2.75 9.49997 2.75 9.08997C2.75 8.67997 3.09 8.33997 3.5 8.33997H20.5C20.91 8.33997 21.25 8.67997 21.25 9.08997C21.25 9.49997 20.91 9.83997 20.5 9.83997Z' fill='%23292D32'/%3E%3Cpath d='M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V17C21.75 20.65 19.65 22.75 16 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z' fill='%23292D32'/%3E%3Cpath d='M8.5 14.5C8.37 14.5 8.24 14.47 8.12 14.42C8 14.37 7.89001 14.3 7.79001 14.21C7.70001 14.11 7.62999 14 7.57999 13.88C7.52999 13.76 7.5 13.63 7.5 13.5C7.5 13.24 7.61001 12.98 7.79001 12.79C7.89001 12.7 8 12.63 8.12 12.58C8.3 12.5 8.50001 12.48 8.70001 12.52C8.76001 12.53 8.82 12.55 8.88 12.58C8.94 12.6 9 12.63 9.06 12.67C9.11 12.71 9.15999 12.75 9.20999 12.79C9.24999 12.84 9.29999 12.89 9.32999 12.94C9.36999 13 9.40001 13.06 9.42001 13.12C9.45001 13.18 9.47001 13.24 9.48001 13.3C9.49001 13.37 9.5 13.43 9.5 13.5C9.5 13.76 9.38999 14.02 9.20999 14.21C9.01999 14.39 8.76 14.5 8.5 14.5Z' fill='%23292D32'/%3E%3Cpath d='M12 14.5C11.74 14.5 11.48 14.39 11.29 14.21C11.25 14.16 11.21 14.11 11.17 14.06C11.13 14 11.1 13.94 11.08 13.88C11.05 13.82 11.03 13.76 11.02 13.7C11.01 13.63 11 13.57 11 13.5C11 13.37 11.03 13.24 11.08 13.12C11.13 13 11.2 12.89 11.29 12.79C11.57 12.51 12.02 12.42 12.38 12.58C12.51 12.63 12.61 12.7 12.71 12.79C12.89 12.98 13 13.24 13 13.5C13 13.57 12.99 13.63 12.98 13.7C12.97 13.76 12.95 13.82 12.92 13.88C12.9 13.94 12.87 14 12.83 14.06C12.79 14.11 12.75 14.16 12.71 14.21C12.61 14.3 12.51 14.37 12.38 14.42C12.26 14.47 12.13 14.5 12 14.5Z' fill='%23292D32'/%3E%3Cpath d='M8.5 18C8.37 18 8.24 17.97 8.12 17.92C8 17.87 7.89001 17.8 7.79001 17.71C7.70001 17.61 7.62999 17.51 7.57999 17.38C7.52999 17.26 7.5 17.13 7.5 17C7.5 16.74 7.61001 16.48 7.79001 16.29C7.89001 16.2 8 16.13 8.12 16.08C8.49 15.92 8.92999 16.01 9.20999 16.29C9.24999 16.34 9.29999 16.39 9.32999 16.44C9.36999 16.5 9.40001 16.56 9.42001 16.62C9.45001 16.68 9.47001 16.74 9.48001 16.81C9.49001 16.87 9.5 16.94 9.5 17C9.5 17.26 9.38999 17.52 9.20999 17.71C9.01999 17.89 8.76 18 8.5 18Z' fill='%23292D32'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position-x: 93%;
    background-position-y: center;
    cursor: pointer;
  }

  .react-datepicker-wrapper input:focus {
    border: 1px solid #4a154b;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.08);
    outline: 0;
  }
  .monthlyDate .react-datepicker-popper {
    width: max-content;
  }
  .monthlyDate .react-datepicker__month-text {
    padding: 0.9rem 0;
    width: 5.1rem;
    display: inline-block;
    font-size: 0.875rem;
    margin: 0.125rem;
  }
  .monthlyDate .react-datepicker__month-text--keyboard-selected {
    background-color: #f8f8f8;
    color: #000;
    font-weight: bolder;
  }
  .monthlyDate .react-datepicker__header {
    background-color: #fff;
    border: none;
    padding-top: 1.25rem;
  }
  .monthlyDate .react-datepicker__navigation {
    align-items: center;
    display: flex;
    padding: 0;
    text-align: center;
    top: 17px;
  }
  .monthlyDate .react-datepicker__navigation--previous {
    left: 0.4375rem;
  }
  .monthlyDate .react-datepicker__navigation--next {
    rigth: 0.4375rem;
  }
  .monthlyDate .react-datepicker__navigation-icon:before {
    border-color: #232323;
    border-width: 1.5px 1.5px 0 0;
  }
  .monthlyDate .react-datepicker__day--in-range {
    background-color: #f15845;
  }
  .monthlyDate .react-datepicker__day--keyboard-selected {
    //  color: #fff;
  }
  .monthlyDate .react-datepicker__day--today {
    font-weight: 800;
  }
  .react-datepicker__day--selected.react-datepicker__day--today{
  color: #fff
  }
  .react-datepicker__day--in-range.react-datepicker__day--in-range {
  color: #fff
  }
  .react-datepicker__month-text--in-range {
    background-color: #f15845;
  }
  .react-datepicker__day--keyboard-selected {
    background-color: #ffffff;
  }
  .react-datepicker__day--selected {
    background-color: #f15845;
  }
`;
const Dashboard = () => {
  const dispatch = useAppDispatch();
  const [analytics, setAnalytics] = useState<any>(null);
  const [projects, setProjects] = useState<any>(null);
  const [timeSpentProject, setTimeSpentProject] = useState<any>(null);
  const [timeSpentTasks, setTimeSpentTasks] = useState<any>(null);
  const today = new Date();
  const dayOfWeek = today.getDay();
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - ((dayOfWeek + 6) % 7));
  const [startDate, setStartDate] = useState(startOfWeek);
  const [endDate, setEndDate] = useState(() => {
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(endOfWeek.getDate() + 6);
    return endOfWeek;
  });
  const isFetching = useRef(false);
  
  const onChangeDate = (value: any) => {
    const selectedDate = value[0];
    const dayOfWeek = selectedDate.getDay();
    const startOfWeek = new Date(selectedDate);
    startOfWeek.setDate(selectedDate.getDate() - ((dayOfWeek + 6) % 7));

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    setStartDate(startOfWeek);
    setEndDate(endOfWeek);
  };

  const filterFutureDates = (date: Date) => {
    const today = new Date();
    return date <= today;
  };

  useEffect(() => {
    if (isFetching.current) return; 

    isFetching.current = true;
    const request: any = {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      // organizationId: res.payload.records? res.payload.records[0].id: "",
    };
    dispatch(getDasboardAsync(request)).then((res) => {
      if (res.payload) {
        setAnalytics(res.payload.analytics);
        setProjects(res.payload.onGoingProjects);
        setTimeSpentProject(res.payload.timeSpentOnProjects);
        setTimeSpentTasks(res.payload.timeSpentOnTasks);
        isFetching.current = false;
      }
    });
  }, [startDate, endDate]);

  return (
    <div className="pb-[1.125rem]" id="pulseDashboard">
      <div className="flex justify-end mb-2.5">
        <EchoPulseDatePicker>
          <div className="w-[9.25rem] monthlyDate">
            <DatePicker
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              onChange={onChangeDate}
              dateFormat="dd MMM"
              showIcon
              filterDate={filterFutureDates}
              onFocus={(e: any) => e.target.blur()}
            />
          </div>
        </EchoPulseDatePicker>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <div className="">
          {analytics ? (
            <DashboardOverview analytics={analytics} startDate={startDate} />
          ) : (
            <DashboardOverviewEmpty />
          )}

          <TimeSpentTask timeSpentTasks={timeSpentTasks} />
        </div>
        <div className="">
          <TimeSpentProject timeSpentProject={timeSpentProject} />

          {projects?.length > 0 ? (
            <OnGoingProject projects={projects} />
          ) : (
            <OnGoingProjectEmpty />
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
